import React, { useEffect, useState } from 'react';
import { useDashboard } from '../../context/DashboardContext';
import { fetchManagerComments } from '../../api/approvalsApi';
import { fmtWhen } from '../admin/ApprovalTable';
import '../../styles/adminApproval.css';

/**
 * 「コメント」 tab (stylist) — the manager's 確定 comments, newest first. Read-only.
 * The same text is injected into AI相談 on the server (dossier), so the agent can read it.
 */
export default function CommentsScreen() {
  const { selectedStore, selectedStylist } = useDashboard();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!selectedStore || !selectedStylist) return;
    let cancelled = false;
    setRows(null);
    fetchManagerComments({ store: selectedStore, stylist: selectedStylist })
      .then((d) => { if (!cancelled) setRows(d.comments || []); })
      .catch((err) => { if (!cancelled) { setError(err.message || '読み込みに失敗しました'); setRows([]); } });
    return () => { cancelled = true; };
  }, [selectedStore, selectedStylist]);

  return (
    <div className="cmt-screen">
      <p className="apv-cap" style={{ marginBottom: 10 }}>
        マネージャーが確定時に残したコメントの履歴です。新しい順。AI相談でも読めます。
      </p>
      {error && <div className="adm-error" role="alert">{error}</div>}
      {rows == null && !error && <div className="apv-empty">読み込み中…</div>}
      {rows && rows.length === 0 && !error && (
        <div className="apv-empty">マネージャーからのコメントはまだありません</div>
      )}
      {rows && rows.map((c) => (
        <div className="cmt" key={c.id}>
          <div className="cmt-h">
            <span className="cmt-from">{c.from}</span>
            <span className="cmt-at">{fmtWhen(c.at)}</span>
          </div>
          {/* plain = 確定 without a note: a history line, nothing is handed to the AI */}
          <div className="cmt-kind">{c.plain ? c.kind : `${c.kind} · AI相談にも渡っています`}</div>
          <div className="cmt-t">{c.text}</div>
        </div>
      ))}
    </div>
  );
}
